import { JSX } from 'react';

import { PayButton } from '@/components/pages/stored-instruments/utils/PayButton';
import NavigationService, {
  InternalPage,
} from '@/services/navigation/NavigationService';

interface IPayWithBankTransferBtnProps {
  navigation?: JSX.Element | null;
}

export function PayWithBankTransferBtn({
  navigation,
}: IPayWithBankTransferBtnProps) {
  return (
    <div className="flex space-x-2">
      {navigation}
      <PayButton
        onClick={() => {
          NavigationService.navigateTo({ page: InternalPage.BankTransfer });
        }}
      />
    </div>
  );
}
